import { EntityRepository, Repository } from "typeorm";

import { ApplyCoOdLeaves } from "../apply-for-od-co.entity";

@EntityRepository(ApplyCoOdLeaves)
export class ApplyOdCoRepository extends Repository<ApplyCoOdLeaves> {
    // Custom repository methods can be defined here
}
